module.exports = __webpack_public_path__ + "static/media/Content2-RoadHazardWarrantyLeaflet_A5_2019_.9f0d129e.pdf";